import { useCallback } from "react";

/**
 * Provides a function to handle horizontal scrolling using the mouse wheel.
 *
 * @param scrollSpeed - The speed at which the container should scroll horizontally when the mouse wheel is used.
 * @returns An object with an `onWheel` property that can be used to bind the horizontal scroll handling to a DOM element.
 */
export const useHorizontalScroll = (scrollSpeed = 1) => {
  const handleWheel = useCallback(
    (e: React.WheelEvent) => {
      e.preventDefault();
      e.stopPropagation();
      const container = e.currentTarget as HTMLElement;
      container.scrollLeft += e.deltaY * scrollSpeed;
    },
    [scrollSpeed]
  );

  const bind = {
    onWheel: handleWheel
  };

  return bind;
};
